/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  palette: {
    primary: {
      1: {
        key: "{palette.primary.1}",
        $value: {
          light: "(color.runtime.accent.light.1)",
          dark: "(color.runtime.accent.dark.1)",
        },
      },
      2: {
        key: "{palette.primary.2}",
        $value: {
          light: "(color.runtime.accent.light.2)",
          dark: "(color.runtime.accent.dark.2)",
        },
      },
      3: {
        key: "{palette.primary.3}",
        $value: {
          light: "(color.runtime.accent.light.3)",
          dark: "(color.runtime.accent.dark.3)",
        },
      },
      4: {
        key: "{palette.primary.4}",
        $value: {
          light: "(color.runtime.accent.light.4)",
          dark: "(color.runtime.accent.dark.4)",
        },
      },
      5: {
        key: "{palette.primary.5}",
        $value: {
          light: "(color.runtime.accent.light.5)",
          dark: "(color.runtime.accent.dark.5)",
        },
      },
      6: {
        key: "{palette.primary.6}",
        $value: {
          light: "(color.runtime.accent.light.6)",
          dark: "(color.runtime.accent.dark.6)",
        },
      },
      7: {
        key: "{palette.primary.7}",
        $value: {
          light: "(color.runtime.accent.light.7)",
          dark: "(color.runtime.accent.dark.7)",
        },
      },
      8: {
        key: "{palette.primary.8}",
        $value: {
          light: "(color.runtime.accent.light.8)",
          dark: "(color.runtime.accent.dark.8)",
        },
      },
      9: {
        key: "{palette.primary.9}",
        $value: {
          light: "(color.runtime.accent.light.9)",
          dark: "(color.runtime.accent.dark.9)",
        },
      },
      10: {
        key: "{palette.primary.10}",
        $value: {
          light: "(color.runtime.accent.light.10)",
          dark: "(color.runtime.accent.dark.10)",
        },
      },
      11: {
        key: "{palette.primary.11}",
        $value: {
          light: "(color.runtime.accent.light.11)",
          dark: "(color.runtime.accent.dark.11)",
        },
      },
      12: {
        key: "{palette.primary.12}",
        $value: {
          light: "(color.runtime.accent.light.12)",
          dark: "(color.runtime.accent.dark.12)",
        },
      },
      50: {
        key: "{palette.primary.50}",
        $value: {
          light: "(color.runtime.accent.light.3)",
          dark: "(color.runtime.accent.light.3)",
        },
      },
      100: {
        key: "{palette.primary.100}",
        $value: {
          light: "(color.runtime.accent.light.5)",
          dark: "(color.runtime.accent.light.5)",
        },
      },
      200: {
        key: "{palette.primary.200}",
        $value: {
          light: "(color.runtime.accent.light.6)",
          dark: "(color.runtime.accent.light.6)",
        },
      },
      300: {
        key: "{palette.primary.300}",
        $value: {
          light: "(color.runtime.accent.light.7)",
          dark: "(color.runtime.accent.light.7)",
        },
      },
      400: {
        key: "{palette.primary.400}",
        $value: {
          light: "(color.runtime.accent.dark.11)",
          dark: "(color.runtime.accent.dark.11)",
        },
      },
      500: {
        key: "{palette.primary.500}",
        $value: {
          light: "(color.runtime.accent.light.9)",
          dark: "(color.runtime.accent.light.9)",
        },
      },
      600: {
        key: "{palette.primary.600}",
        $value: {
          light: "(color.runtime.accent.light.11)",
          dark: "(color.runtime.accent.light.11)",
        },
      },
      700: {
        key: "{palette.primary.700}",
        $value: {
          light: "(color.runtime.accent.dark.6)",
          dark: "(color.runtime.accent.dark.6)",
        },
      },
      800: {
        key: "{palette.primary.800}",
        $value: {
          light: "(color.runtime.accent.dark.5)",
          dark: "(color.runtime.accent.dark.5)",
        },
      },
      900: {
        key: "{palette.primary.900}",
        $value: {
          light: "(color.runtime.accent.dark.4)",
          dark: "(color.runtime.accent.dark.4)",
        },
      },
      950: {
        key: "{palette.primary.950}",
        $value: {
          light: "(color.runtime.accent.dark.3)",
          dark: "(color.runtime.accent.dark.3)",
        },
      },
      lightest: {
        key: "{palette.primary.lightest}",
        $value: {
          light: "(color.runtime.accent.light.4)",
          dark: "(color.runtime.accent.light.4)",
        },
      },
      light: {
        key: "{palette.primary.light}",
        $value: {
          light: "(color.runtime.accent.dark.11)",
          dark: "(color.runtime.accent.dark.11)",
        },
      },
      main: {
        key: "{palette.primary.main}",
        $value: {
          light: "(color.runtime.accent.light.9)",
          dark: "(color.runtime.accent.dark.9)",
        },
      },
      dark: {
        key: "{palette.primary.dark}",
        $value: {
          light: "(color.runtime.accent.light.11)",
          dark: "(color.runtime.accent.light.11)",
        },
      },
      darkest: {
        key: "{palette.primary.darkest}",
        $value: {
          light: "(color.runtime.accent.dark.6)",
          dark: "(color.runtime.accent.dark.6)",
        },
      },
      contrast: {
        key: "{palette.primary.contrast}",
        $value: {
          light: "(color.runtime.accent.light.contrast)",
          dark: "(color.runtime.accent.dark.contrast)",
        },
      },
      borderRegular: {
        key: "{palette.primary.borderRegular}",
        $value: {
          light: "(color.runtime.accent.light.a7)",
          dark: "(color.runtime.accent.dark.a7)",
        },
      },
      track: {
        key: "{palette.primary.track}",
        $value: {
          light: "(color.runtime.accent.light.9)",
          dark: "(color.runtime.accent.dark.9)",
        },
      },
      a1: {
        key: "{palette.primary.a1}",
        $value: {
          light: "(color.runtime.accent.light.a1)",
          dark: "(color.runtime.accent.dark.a1)",
        },
      },
      a2: {
        key: "{palette.primary.a2}",
        $value: {
          light: "(color.runtime.accent.light.a2)",
          dark: "(color.runtime.accent.dark.a2)",
        },
      },
      a3: {
        key: "{palette.primary.a3}",
        $value: {
          light: "(color.runtime.accent.light.a3)",
          dark: "(color.runtime.accent.dark.a3)",
        },
      },
      a4: {
        key: "{palette.primary.a4}",
        $value: {
          light: "(color.runtime.accent.light.a4)",
          dark: "(color.runtime.accent.dark.a4)",
        },
      },
      a5: {
        key: "{palette.primary.a5}",
        $value: {
          light: "(color.runtime.accent.light.a5)",
          dark: "(color.runtime.accent.dark.a5)",
        },
      },
      a6: {
        key: "{palette.primary.a6}",
        $value: {
          light: "(color.runtime.accent.light.a6)",
          dark: "(color.runtime.accent.dark.a6)",
        },
      },
      a7: {
        key: "{palette.primary.a7}",
        $value: {
          light: "(color.runtime.accent.light.a7)",
          dark: "(color.runtime.accent.dark.a7)",
        },
      },
      a8: {
        key: "{palette.primary.a8}",
        $value: {
          light: "(color.runtime.accent.light.a8)",
          dark: "(color.runtime.accent.dark.a8)",
        },
      },
      a9: {
        key: "{palette.primary.a9}",
        $value: {
          light: "(color.runtime.accent.light.a9)",
          dark: "(color.runtime.accent.dark.a9)",
        },
      },
      a10: {
        key: "{palette.primary.a10}",
        $value: {
          light: "(color.runtime.accent.light.a10)",
          dark: "(color.runtime.accent.dark.a10)",
        },
      },
      a11: {
        key: "{palette.primary.a11}",
        $value: {
          light: "(color.runtime.accent.light.a11)",
          dark: "(color.runtime.accent.dark.a11)",
        },
      },
      a12: {
        key: "{palette.primary.a12}",
        $value: {
          light: "(color.runtime.accent.light.a12)",
          dark: "(color.runtime.accent.dark.a12)",
        },
      },
      indicator: {
        key: "{palette.primary.indicator}",
        $value: {
          light: "(color.runtime.accent.light.9)",
          dark: "(color.runtime.accent.dark.9)",
        },
      },
      surface: {
        key: "{palette.primary.surface}",
        $value: {
          light: "(color.runtime.accent.light.surface)",
          dark: "(color.runtime.accent.dark.surface)",
        },
      },
      borderSubtle: {
        key: "{palette.primary.borderSubtle}",
        $value: {
          light: "(color.runtime.accent.light.a6)",
          dark: "(color.runtime.accent.dark.a6)",
        },
      },
      backgroundSoft: {
        key: "{palette.primary.backgroundSoft}",
        $value: {
          light: "(color.runtime.accent.light.a3)",
          dark: "(color.runtime.accent.dark.a3)",
        },
      },
      text: {
        key: "{palette.primary.text}",
        $value: {
          light: "(color.runtime.accent.light.a11)",
          dark: "(color.runtime.accent.dark.a11)",
        },
      },
      solid: {
        key: "{palette.primary.solid}",
        $value: {
          light: "(color.runtime.accent.light.9)",
          dark: "(color.runtime.accent.dark.9)",
        },
      },
      solidHover: {
        key: "{palette.primary.solidHover}",
        $value: {
          light: "(color.runtime.accent.light.10)",
          dark: "(color.runtime.accent.dark.10)",
        },
      },
      highContrast: {
        key: "{palette.primary.highContrast}",
        $value: {
          light: "(color.runtime.accent.light.a12)",
          dark: "(color.runtime.accent.dark.a12)",
        },
      },
      backgroundSubtle: {
        key: "{palette.primary.backgroundSubtle}",
        $value: {
          light: "(color.runtime.accent.light.a2)",
          dark: "(color.runtime.accent.dark.a2)",
        },
      },
      backgroundSoftHover: {
        key: "{palette.primary.backgroundSoftHover}",
        $value: {
          light: "(color.runtime.accent.light.a4)",
          dark: "(color.runtime.accent.dark.a4)",
        },
      },
      backgroundSoftActive: {
        key: "{palette.primary.backgroundSoftActive}",
        $value: {
          light: "(color.runtime.accent.light.a5)",
          dark: "(color.runtime.accent.dark.a5)",
        },
      },
      borderStrong: {
        key: "{palette.primary.borderStrong}",
        $value: {
          light: "(color.runtime.accent.light.a8)",
          dark: "(color.runtime.accent.dark.a8)",
        },
      },
      backgroundSubtlest: {
        key: "{palette.primary.backgroundSubtlest}",
        $value: {
          light: "(color.runtime.accent.light.a1)",
          dark: "(color.runtime.accent.dark.a1)",
        },
      },
      onHighContrast: {
        key: "{palette.primary.onHighContrast}",
        $value: {
          light: "(color.runtime.accent.dark.12)",
          dark: "(color.runtime.accent.light.12)",
        },
      },
    },
    secondary: {
      1: {
        key: "{palette.secondary.1}",
        $value: {
          light: "(color.runtime.gray.light.1)",
          dark: "(color.runtime.gray.dark.1)",
        },
      },
      2: {
        key: "{palette.secondary.2}",
        $value: {
          light: "(color.runtime.gray.light.2)",
          dark: "(color.runtime.gray.dark.2)",
        },
      },
      3: {
        key: "{palette.secondary.3}",
        $value: {
          light: "(color.runtime.gray.light.3)",
          dark: "(color.runtime.gray.dark.3)",
        },
      },
      4: {
        key: "{palette.secondary.4}",
        $value: {
          light: "(color.runtime.gray.light.4)",
          dark: "(color.runtime.gray.dark.4)",
        },
      },
      5: {
        key: "{palette.secondary.5}",
        $value: {
          light: "(color.runtime.gray.light.5)",
          dark: "(color.runtime.gray.dark.5)",
        },
      },
      6: {
        key: "{palette.secondary.6}",
        $value: {
          light: "(color.runtime.gray.light.6)",
          dark: "(color.runtime.gray.dark.6)",
        },
      },
      7: {
        key: "{palette.secondary.7}",
        $value: {
          light: "(color.runtime.gray.light.7)",
          dark: "(color.runtime.gray.dark.7)",
        },
      },
      8: {
        key: "{palette.secondary.8}",
        $value: {
          light: "(color.runtime.gray.light.8)",
          dark: "(color.runtime.gray.dark.8)",
        },
      },
      9: {
        key: "{palette.secondary.9}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      10: {
        key: "{palette.secondary.10}",
        $value: {
          light: "(color.runtime.gray.light.10)",
          dark: "(color.runtime.gray.dark.10)",
        },
      },
      11: {
        key: "{palette.secondary.11}",
        $value: {
          light: "(color.runtime.gray.light.11)",
          dark: "(color.runtime.gray.dark.11)",
        },
      },
      12: {
        key: "{palette.secondary.12}",
        $value: {
          light: "(color.runtime.gray.light.12)",
          dark: "(color.runtime.gray.dark.12)",
        },
      },
      50: {
        key: "{palette.secondary.50}",
        $value: {
          light: "(color.runtime.gray.light.2)",
          dark: "(color.runtime.gray.light.2)",
        },
      },
      100: {
        key: "{palette.secondary.100}",
        $value: {
          light: "(color.runtime.gray.light.3)",
          dark: "(color.runtime.gray.light.3)",
        },
      },
      200: {
        key: "{palette.secondary.200}",
        $value: {
          light: "(color.runtime.gray.light.5)",
          dark: "(color.runtime.gray.light.5)",
        },
      },
      300: {
        key: "{palette.secondary.300}",
        $value: {
          light: "(color.runtime.gray.light.8)",
          dark: "(color.runtime.gray.light.8)",
        },
      },
      400: {
        key: "{palette.secondary.400}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.light.9)",
        },
      },
      500: {
        key: "{palette.secondary.500}",
        $value: {
          light: "(color.runtime.gray.light.11)",
          dark: "(color.runtime.gray.light.11)",
        },
      },
      600: {
        key: "{palette.secondary.600}",
        $value: {
          light: "(color.runtime.gray.dark.7)",
          dark: "(color.runtime.gray.dark.7)",
        },
      },
      700: {
        key: "{palette.secondary.700}",
        $value: {
          light: "(color.runtime.gray.dark.6)",
          dark: "(color.runtime.gray.dark.6)",
        },
      },
      800: {
        key: "{palette.secondary.800}",
        $value: {
          light: "(color.runtime.gray.dark.5)",
          dark: "(color.runtime.gray.dark.5)",
        },
      },
      900: {
        key: "{palette.secondary.900}",
        $value: {
          light: "(color.runtime.gray.dark.4)",
          dark: "(color.runtime.gray.dark.4)",
        },
      },
      950: {
        key: "{palette.secondary.950}",
        $value: {
          light: "(color.runtime.gray.dark.2)",
          dark: "(color.runtime.gray.dark.2)",
        },
      },
      lightest: {
        key: "{palette.secondary.lightest}",
        $value: {
          light: "(color.runtime.gray.light.4)",
          dark: "(color.runtime.gray.light.3)",
        },
      },
      light: {
        key: "{palette.secondary.light}",
        $value: {
          light: "(color.runtime.gray.light.8)",
          dark: "(color.runtime.gray.light.7)",
        },
      },
      main: {
        key: "{palette.secondary.main}",
        $value: {
          light: "(color.runtime.gray.light.11)",
          dark: "(color.runtime.gray.dark.11)",
        },
      },
      dark: {
        key: "{palette.secondary.dark}",
        $value: {
          light: "(color.runtime.gray.dark.7)",
          dark: "(color.runtime.gray.dark.8)",
        },
      },
      darkest: {
        key: "{palette.secondary.darkest}",
        $value: {
          light: "(color.runtime.gray.dark.5)",
          dark: "(color.runtime.gray.dark.6)",
        },
      },
      contrast: {
        key: "{palette.secondary.contrast}",
        $value: {
          light: "(color.runtime.gray.light.contrast)",
          dark: "(color.runtime.gray.dark.contrast)",
        },
      },
      borderRegular: {
        key: "{palette.secondary.borderRegular}",
        $value: {
          light: "(color.runtime.gray.light.a7)",
          dark: "(color.runtime.gray.dark.a7)",
        },
      },
      track: {
        key: "{palette.secondary.track}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      a12: {
        key: "{palette.secondary.a12}",
        $value: {
          light: "(color.runtime.gray.light.a12)",
          dark: "(color.runtime.gray.dark.a12)",
        },
      },
      a10: {
        key: "{palette.secondary.a10}",
        $value: {
          light: "(color.runtime.gray.light.a10)",
          dark: "(color.runtime.gray.dark.a10)",
        },
      },
      a8: {
        key: "{palette.secondary.a8}",
        $value: {
          light: "(color.runtime.gray.light.a8)",
          dark: "(color.runtime.gray.dark.a8)",
        },
      },
      a7: {
        key: "{palette.secondary.a7}",
        $value: {
          light: "(color.runtime.gray.light.a7)",
          dark: "(color.runtime.gray.dark.a7)",
        },
      },
      a5: {
        key: "{palette.secondary.a5}",
        $value: {
          light: "(color.runtime.gray.light.a5)",
          dark: "(color.runtime.gray.dark.a5)",
        },
      },
      a2: {
        key: "{palette.secondary.a2}",
        $value: {
          light: "(color.runtime.gray.light.a2)",
          dark: "(color.runtime.gray.dark.a2)",
        },
      },
      a3: {
        key: "{palette.secondary.a3}",
        $value: {
          light: "(color.runtime.gray.light.a3)",
          dark: "(color.runtime.gray.dark.a3)",
        },
      },
      a1: {
        key: "{palette.secondary.a1}",
        $value: {
          light: "(color.runtime.gray.light.a1)",
          dark: "(color.runtime.gray.dark.a1)",
        },
      },
      a6: {
        key: "{palette.secondary.a6}",
        $value: {
          light: "(color.runtime.gray.light.a6)",
          dark: "(color.runtime.gray.dark.a6)",
        },
      },
      a11: {
        key: "{palette.secondary.a11}",
        $value: {
          light: "(color.runtime.gray.light.a11)",
          dark: "(color.runtime.gray.dark.a11)",
        },
      },
      a4: {
        key: "{palette.secondary.a4}",
        $value: {
          light: "(color.runtime.gray.light.a4)",
          dark: "(color.runtime.gray.dark.a4)",
        },
      },
      a9: {
        key: "{palette.secondary.a9}",
        $value: {
          light: "(color.runtime.gray.light.a9)",
          dark: "(color.runtime.gray.dark.a9)",
        },
      },
      indicator: {
        key: "{palette.secondary.indicator}",
        $value: {
          light: "(color.runtime.gray.light.12)",
          dark: "(color.runtime.gray.dark.12)",
        },
      },
      surface: {
        key: "{palette.secondary.surface}",
        $value: {
          light: "(color.runtime.gray.light.surface)",
          dark: "(color.runtime.gray.dark.surface)",
        },
      },
      backgroundSubtle: {
        key: "{palette.secondary.backgroundSubtle}",
        $value: {
          light: "(color.runtime.gray.light.a2)",
          dark: "(color.runtime.gray.dark.a2)",
        },
      },
      highContrast: {
        key: "{palette.secondary.highContrast}",
        $value: {
          light: "(color.runtime.gray.light.a12)",
          dark: "(color.runtime.gray.dark.a12)",
        },
      },
      text: {
        key: "{palette.secondary.text}",
        $value: {
          light: "(color.runtime.gray.light.a11)",
          dark: "(color.runtime.gray.dark.a11)",
        },
      },
      solid: {
        key: "{palette.secondary.solid}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      backgroundSoft: {
        key: "{palette.secondary.backgroundSoft}",
        $value: {
          light: "(color.runtime.gray.light.a3)",
          dark: "(color.runtime.gray.dark.a3)",
        },
      },
      solidHover: {
        key: "{palette.secondary.solidHover}",
        $value: {
          light: "(color.runtime.gray.light.10)",
          dark: "(color.runtime.gray.dark.10)",
        },
      },
      borderSubtle: {
        key: "{palette.secondary.borderSubtle}",
        $value: {
          light: "(color.runtime.gray.light.a6)",
          dark: "(color.runtime.gray.dark.a6)",
        },
      },
      backgroundSubtlest: {
        key: "{palette.secondary.backgroundSubtlest}",
        $value: {
          light: "(color.runtime.gray.light.a1)",
          dark: "(color.runtime.gray.dark.a1)",
        },
      },
      backgroundSoftHover: {
        key: "{palette.secondary.backgroundSoftHover}",
        $value: {
          light: "(color.runtime.gray.light.a4)",
          dark: "(color.runtime.gray.dark.a4)",
        },
      },
      backgroundSoftActive: {
        key: "{palette.secondary.backgroundSoftActive}",
        $value: {
          light: "(color.runtime.gray.light.a5)",
          dark: "(color.runtime.gray.dark.a5)",
        },
      },
      borderStrong: {
        key: "{palette.secondary.borderStrong}",
        $value: {
          light: "(color.runtime.gray.light.a8)",
          dark: "(color.runtime.gray.dark.a8)",
        },
      },
      onHighContrast: {
        key: "{palette.secondary.onHighContrast}",
        $value: {
          light: "(color.runtime.gray.dark.12)",
          dark: "(color.runtime.gray.light.12)",
        },
      },
    },
    info: {
      1: {
        key: "{palette.info.1}",
        $value: {
          light: "(color.runtime.gray.light.1)",
          dark: "(color.runtime.gray.dark.1)",
        },
      },
      2: {
        key: "{palette.info.2}",
        $value: {
          light: "(color.runtime.gray.light.2)",
          dark: "(color.runtime.gray.dark.2)",
        },
      },
      3: {
        key: "{palette.info.3}",
        $value: {
          light: "(color.runtime.gray.light.3)",
          dark: "(color.runtime.gray.dark.3)",
        },
      },
      4: {
        key: "{palette.info.4}",
        $value: {
          light: "(color.runtime.gray.light.4)",
          dark: "(color.runtime.gray.dark.4)",
        },
      },
      5: {
        key: "{palette.info.5}",
        $value: {
          light: "(color.runtime.gray.light.5)",
          dark: "(color.runtime.gray.dark.5)",
        },
      },
      6: {
        key: "{palette.info.6}",
        $value: {
          light: "(color.runtime.gray.light.6)",
          dark: "(color.runtime.gray.dark.6)",
        },
      },
      7: {
        key: "{palette.info.7}",
        $value: {
          light: "(color.runtime.gray.light.7)",
          dark: "(color.runtime.gray.dark.7)",
        },
      },
      8: {
        key: "{palette.info.8}",
        $value: {
          light: "(color.runtime.gray.light.8)",
          dark: "(color.runtime.gray.dark.8)",
        },
      },
      9: {
        key: "{palette.info.9}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      10: {
        key: "{palette.info.10}",
        $value: {
          light: "(color.runtime.gray.light.10)",
          dark: "(color.runtime.gray.dark.10)",
        },
      },
      11: {
        key: "{palette.info.11}",
        $value: {
          light: "(color.runtime.gray.light.11)",
          dark: "(color.runtime.gray.dark.11)",
        },
      },
      12: {
        key: "{palette.info.12}",
        $value: {
          light: "(color.runtime.gray.light.12)",
          dark: "(color.runtime.gray.dark.12)",
        },
      },
      50: {
        key: "{palette.info.50}",
        $value: {
          light: "(color.runtime.gray.light.2)",
          dark: "(color.runtime.gray.light.2)",
        },
      },
      100: {
        key: "{palette.info.100}",
        $value: {
          light: "(color.runtime.gray.light.3)",
          dark: "(color.runtime.gray.light.3)",
        },
      },
      200: {
        key: "{palette.info.200}",
        $value: {
          light: "(color.runtime.gray.light.5)",
          dark: "(color.runtime.gray.light.5)",
        },
      },
      300: {
        key: "{palette.info.300}",
        $value: {
          light: "(color.runtime.gray.light.8)",
          dark: "(color.runtime.gray.light.8)",
        },
      },
      400: {
        key: "{palette.info.400}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.light.9)",
        },
      },
      500: {
        key: "{palette.info.500}",
        $value: {
          light: "(color.runtime.gray.light.11)",
          dark: "(color.runtime.gray.light.11)",
        },
      },
      600: {
        key: "{palette.info.600}",
        $value: {
          light: "(color.runtime.gray.dark.7)",
          dark: "(color.runtime.gray.dark.7)",
        },
      },
      700: {
        key: "{palette.info.700}",
        $value: {
          light: "(color.runtime.gray.dark.6)",
          dark: "(color.runtime.gray.dark.6)",
        },
      },
      800: {
        key: "{palette.info.800}",
        $value: {
          light: "(color.runtime.gray.dark.5)",
          dark: "(color.runtime.gray.dark.5)",
        },
      },
      900: {
        key: "{palette.info.900}",
        $value: {
          light: "(color.runtime.gray.dark.4)",
          dark: "(color.runtime.gray.dark.4)",
        },
      },
      950: {
        key: "{palette.info.950}",
        $value: {
          light: "(color.runtime.gray.dark.2)",
          dark: "(color.runtime.gray.dark.2)",
        },
      },
      lightest: {
        key: "{palette.info.lightest}",
        $value: {
          light: "(color.runtime.gray.light.4)",
          dark: "(color.runtime.gray.light.3)",
        },
      },
      light: {
        key: "{palette.info.light}",
        $value: {
          light: "(color.runtime.gray.light.8)",
          dark: "(color.runtime.gray.light.7)",
        },
      },
      main: {
        key: "{palette.info.main}",
        $value: {
          light: "(color.runtime.gray.light.11)",
          dark: "(color.runtime.gray.dark.11)",
        },
      },
      dark: {
        key: "{palette.info.dark}",
        $value: {
          light: "(color.runtime.gray.dark.7)",
          dark: "(color.runtime.gray.dark.8)",
        },
      },
      darkest: {
        key: "{palette.info.darkest}",
        $value: {
          light: "(color.runtime.gray.dark.5)",
          dark: "(color.runtime.gray.dark.6)",
        },
      },
      contrast: {
        key: "{palette.info.contrast}",
        $value: {
          light: "(color.runtime.gray.light.contrast)",
          dark: "(color.runtime.gray.dark.contrast)",
        },
      },
      borderRegular: {
        key: "{palette.info.borderRegular}",
        $value: {
          light: "(color.runtime.gray.light.a7)",
          dark: "(color.runtime.gray.dark.a7)",
        },
      },
      a11: {
        key: "{palette.info.a11}",
        $value: {
          light: "(color.runtime.gray.light.a11)",
          dark: "(color.runtime.gray.dark.a11)",
        },
      },
      a1: {
        key: "{palette.info.a1}",
        $value: {
          light: "(color.runtime.gray.light.a1)",
          dark: "(color.runtime.gray.dark.a1)",
        },
      },
      a9: {
        key: "{palette.info.a9}",
        $value: {
          light: "(color.runtime.gray.light.a9)",
          dark: "(color.runtime.gray.dark.a9)",
        },
      },
      a12: {
        key: "{palette.info.a12}",
        $value: {
          light: "(color.runtime.gray.light.a12)",
          dark: "(color.runtime.gray.dark.a12)",
        },
      },
      a8: {
        key: "{palette.info.a8}",
        $value: {
          light: "(color.runtime.gray.light.a8)",
          dark: "(color.runtime.gray.dark.a8)",
        },
      },
      a5: {
        key: "{palette.info.a5}",
        $value: {
          light: "(color.runtime.gray.light.a5)",
          dark: "(color.runtime.gray.dark.a5)",
        },
      },
      a4: {
        key: "{palette.info.a4}",
        $value: {
          light: "(color.runtime.gray.light.a4)",
          dark: "(color.runtime.gray.dark.a4)",
        },
      },
      a2: {
        key: "{palette.info.a2}",
        $value: {
          light: "(color.runtime.gray.light.a2)",
          dark: "(color.runtime.gray.dark.a2)",
        },
      },
      a7: {
        key: "{palette.info.a7}",
        $value: {
          light: "(color.runtime.gray.light.a7)",
          dark: "(color.runtime.gray.dark.a7)",
        },
      },
      a6: {
        key: "{palette.info.a6}",
        $value: {
          light: "(color.runtime.gray.light.a6)",
          dark: "(color.runtime.gray.dark.a6)",
        },
      },
      a10: {
        key: "{palette.info.a10}",
        $value: {
          light: "(color.runtime.gray.light.a10)",
          dark: "(color.runtime.gray.dark.a10)",
        },
      },
      a3: {
        key: "{palette.info.a3}",
        $value: {
          light: "(color.runtime.gray.light.a3)",
          dark: "(color.runtime.gray.dark.a3)",
        },
      },
      indicator: {
        key: "{palette.info.indicator}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      track: {
        key: "{palette.info.track}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      surface: {
        key: "{palette.info.surface}",
        $value: {
          light: "(color.runtime.gray.light.surface)",
          dark: "(color.runtime.gray.dark.surface)",
        },
      },
      backgroundSubtle: {
        key: "{palette.info.backgroundSubtle}",
        $value: {
          light: "(color.runtime.gray.light.a2)",
          dark: "(color.runtime.gray.dark.a2)",
        },
      },
      highContrast: {
        key: "{palette.info.highContrast}",
        $value: {
          light: "(color.runtime.gray.light.a12)",
          dark: "(color.runtime.gray.dark.a12)",
        },
      },
      solidHover: {
        key: "{palette.info.solidHover}",
        $value: {
          light: "(color.runtime.gray.light.10)",
          dark: "(color.runtime.gray.dark.10)",
        },
      },
      solid: {
        key: "{palette.info.solid}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      backgroundSoft: {
        key: "{palette.info.backgroundSoft}",
        $value: {
          light: "(color.runtime.gray.light.a3)",
          dark: "(color.runtime.gray.dark.a3)",
        },
      },
      text: {
        key: "{palette.info.text}",
        $value: {
          light: "(color.runtime.gray.light.a11)",
          dark: "(color.runtime.gray.dark.a11)",
        },
      },
      borderSubtle: {
        key: "{palette.info.borderSubtle}",
        $value: {
          light: "(color.runtime.gray.light.a6)",
          dark: "(color.runtime.gray.dark.a6)",
        },
      },
      backgroundSubtlest: {
        key: "{palette.info.backgroundSubtlest}",
        $value: {
          light: "(color.runtime.gray.light.a1)",
          dark: "(color.runtime.gray.dark.a1)",
        },
      },
      backgroundSoftHover: {
        key: "{palette.info.backgroundSoftHover}",
        $value: {
          light: "(color.runtime.gray.light.a4)",
          dark: "(color.runtime.gray.dark.a4)",
        },
      },
      backgroundSoftActive: {
        key: "{palette.info.backgroundSoftActive}",
        $value: {
          light: "(color.runtime.gray.light.a5)",
          dark: "(color.runtime.gray.dark.a5)",
        },
      },
      borderStrong: {
        key: "{palette.info.borderStrong}",
        $value: {
          light: "(color.runtime.gray.light.a8)",
          dark: "(color.runtime.gray.dark.a8)",
        },
      },
      onHighContrast: {
        key: "{palette.info.onHighContrast}",
        $value: {
          light: "(color.runtime.gray.dark.12)",
          dark: "(color.runtime.gray.light.12)",
        },
      },
    },
    chart: {
      dataset1: {
        key: "{palette.chart.dataset1}",
        $value: {
          light: "(color.runtime.accent.light.9)",
          dark: "(color.runtime.accent.light.9)",
        },
      },
      dataset2: {
        key: "{palette.chart.dataset2}",
        $value: {
          light: "(color.runtime.accent.light.8)",
          dark: "(color.runtime.accent.light.8)",
        },
      },
      dataset3: {
        key: "{palette.chart.dataset3}",
        $value: {
          light: "(color.runtime.accent.light.7)",
          dark: "(color.runtime.accent.light.7)",
        },
      },
      dataset4: {
        key: "{palette.chart.dataset4}",
        $value: {
          light: "(color.runtime.accent.light.6)",
          dark: "(color.runtime.accent.light.6)",
        },
      },
      dataset5: {
        key: "{palette.chart.dataset5}",
        $value: {
          light: "(color.runtime.accent.light.5)",
          dark: "(color.runtime.accent.light.5)",
        },
      },
      dataset6: {
        key: "{palette.chart.dataset6}",
        $value: {
          light: "(color.runtime.accent.light.4)",
          dark: "(color.runtime.accent.light.4)",
        },
      },
    },
    darkToLight: {
      key: "{palette.darkToLight}",
      $value: {
        light: "(color.runtime.gray.light.12)",
        dark: "#ffffff",
      },
    },
  },
  color: {
    runtime: {
      accent: {
        light: {
          1: {
            key: "{color.runtime.accent.light.1}",
            $value: "#fbfdff",
          },
          2: {
            key: "{color.runtime.accent.light.2}",
            $value: "#f4faff",
          },
          3: {
            key: "{color.runtime.accent.light.3}",
            $value: "#e8f3ff",
          },
          4: {
            key: "{color.runtime.accent.light.4}",
            $value: "#d9edff",
          },
          5: {
            key: "{color.runtime.accent.light.5}",
            $value: "#c6e3ff",
          },
          6: {
            key: "{color.runtime.accent.light.6}",
            $value: "#b1d6fd",
          },
          7: {
            key: "{color.runtime.accent.light.7}",
            $value: "#96c5f7",
          },
          8: {
            key: "{color.runtime.accent.light.8}",
            $value: "#6daef0",
          },
          9: {
            key: "{color.runtime.accent.light.9}",
            $value: "#038bed",
          },
          10: {
            key: "{color.runtime.accent.light.10}",
            $value: "#007ee2",
          },
          11: {
            key: "{color.runtime.accent.light.11}",
            $value: "#0075d5",
          },
          12: {
            key: "{color.runtime.accent.light.12}",
            $value: "#003560",
          },
          a11: {
            key: "{color.runtime.accent.light.a11}",
            $value: "#0075d5",
          },
          a12: {
            key: "{color.runtime.accent.light.a12}",
            $value: "#003560",
          },
          a9: {
            key: "{color.runtime.accent.light.a9}",
            $value: "#008aedfc",
          },
          a8: {
            key: "{color.runtime.accent.light.a8}",
            $value: "#0072e591",
          },
          surface: {
            key: "{color.runtime.accent.light.surface}",
            $value: "#f1f9ffcc",
          },
          a2: {
            key: "{color.runtime.accent.light.a2}",
            $value: "#008cff0a",
          },
          a10: {
            key: "{color.runtime.accent.light.a10}",
            $value: "#007ee2",
          },
          a7: {
            key: "{color.runtime.accent.light.a7}",
            $value: "#0073ec69",
          },
          a6: {
            key: "{color.runtime.accent.light.a6}",
            $value: "#0079f94f",
          },
          contrast: {
            key: "{color.runtime.accent.light.contrast}",
            $value: "#ffffff",
          },
          a4: {
            key: "{color.runtime.accent.light.a4}",
            $value: "#0087ff26",
          },
          a3: {
            key: "{color.runtime.accent.light.a3}",
            $value: "#007aff17",
          },
          a5: {
            key: "{color.runtime.accent.light.a5}",
            $value: "#0082ff38",
          },
          a1: {
            key: "{color.runtime.accent.light.a1}",
            $value: "#0080ff05",
          },
        },
        dark: {
          1: {
            key: "{color.runtime.accent.dark.1}",
            $value: "#040b13",
          },
          2: {
            key: "{color.runtime.accent.dark.2}",
            $value: "#0d1823",
          },
          3: {
            key: "{color.runtime.accent.dark.3}",
            $value: "#0a2843",
          },
          4: {
            key: "{color.runtime.accent.dark.4}",
            $value: "#00335d",
          },
          5: {
            key: "{color.runtime.accent.dark.5}",
            $value: "#053f6f",
          },
          6: {
            key: "{color.runtime.accent.dark.6}",
            $value: "#144d80",
          },
          7: {
            key: "{color.runtime.accent.dark.7}",
            $value: "#205e96",
          },
          8: {
            key: "{color.runtime.accent.dark.8}",
            $value: "#2771b4",
          },
          9: {
            key: "{color.runtime.accent.dark.9}",
            $value: "#038bed",
          },
          10: {
            key: "{color.runtime.accent.dark.10}",
            $value: "#007edf",
          },
          11: {
            key: "{color.runtime.accent.dark.11}",
            $value: "#75b9fe",
          },
          12: {
            key: "{color.runtime.accent.dark.12}",
            $value: "#cbe4fe",
          },
          a10: {
            key: "{color.runtime.accent.dark.a10}",
            $value: "#0090ffde",
          },
          contrast: {
            key: "{color.runtime.accent.dark.contrast}",
            $value: "#ffffff",
          },
          a11: {
            key: "{color.runtime.accent.dark.a11}",
            $value: "#75baff",
          },
          a9: {
            key: "{color.runtime.accent.dark.a9}",
            $value: "#0395feed",
          },
          a7: {
            key: "{color.runtime.accent.dark.a7}",
            $value: "#319dfe91",
          },
          a8: {
            key: "{color.runtime.accent.dark.a8}",
            $value: "#349fffb0",
          },
          a5: {
            key: "{color.runtime.accent.dark.a5}",
            $value: "#008bfe69",
          },
          a12: {
            key: "{color.runtime.accent.dark.a12}",
            $value: "#cce5ff",
          },
          a1: {
            key: "{color.runtime.accent.dark.a1}",
            $value: "#0027ee0a",
          },
          a2: {
            key: "{color.runtime.accent.dark.a2}",
            $value: "#3194f71a",
          },
          a6: {
            key: "{color.runtime.accent.dark.a6}",
            $value: "#2095fd7a",
          },
          a3: {
            key: "{color.runtime.accent.dark.a3}",
            $value: "#0e8cfe3b",
          },
          surface: {
            key: "{color.runtime.accent.dark.surface}",
            $value: "#11263b80",
          },
          a4: {
            key: "{color.runtime.accent.dark.a4}",
            $value: "#0083ff57",
          },
        },
      },
      gray: {
        light: {
          1: {
            key: "{color.runtime.gray.light.1}",
            $value: "#fcfcfd",
          },
          2: {
            key: "{color.runtime.gray.light.2}",
            $value: "#f9f9fb",
          },
          3: {
            key: "{color.runtime.gray.light.3}",
            $value: "#f0f0f2",
          },
          4: {
            key: "{color.runtime.gray.light.4}",
            $value: "#e8e8eb",
          },
          5: {
            key: "{color.runtime.gray.light.5}",
            $value: "#e1e1e5",
          },
          6: {
            key: "{color.runtime.gray.light.6}",
            $value: "#d9d9de",
          },
          7: {
            key: "{color.runtime.gray.light.7}",
            $value: "#ceced4",
          },
          8: {
            key: "{color.runtime.gray.light.8}",
            $value: "#bbbbc3",
          },
          9: {
            key: "{color.runtime.gray.light.9}",
            $value: "#8d8d95",
          },
          10: {
            key: "{color.runtime.gray.light.10}",
            $value: "#82828a",
          },
          11: {
            key: "{color.runtime.gray.light.11}",
            $value: "#636369",
          },
          12: {
            key: "{color.runtime.gray.light.12}",
            $value: "#1f1f23",
          },
          contrast: {
            key: "{color.runtime.gray.light.contrast}",
            $value: "#ffffff",
          },
          a10: {
            key: "{color.runtime.gray.light.a10}",
            $value: "#0000117d",
          },
          a7: {
            key: "{color.runtime.gray.light.a7}",
            $value: "#00002030",
          },
          a6: {
            key: "{color.runtime.gray.light.a6}",
            $value: "#00002226",
          },
          a5: {
            key: "{color.runtime.gray.light.a5}",
            $value: "#0000221f",
          },
          a4: {
            key: "{color.runtime.gray.light.a4}",
            $value: "#00002217",
          },
          a3: {
            key: "{color.runtime.gray.light.a3}",
            $value: "#0010300f",
          },
          a2: {
            key: "{color.runtime.gray.light.a2}",
            $value: "#0000220f",
          },
          a1: {
            key: "{color.runtime.gray.light.a1}",
            $value: "#00005503",
          },
          a9: {
            key: "{color.runtime.gray.light.a9}",
            $value: "#00001273",
          },
          a11: {
            key: "{color.runtime.gray.light.a11}",
            $value: "#00000a9c",
          },
          surface: {
            key: "{color.runtime.gray.light.surface}",
            $value: "#ffffffcc",
          },
          a12: {
            key: "{color.runtime.gray.light.a12}",
            $value: "#000005e0",
          },
          a8: {
            key: "{color.runtime.gray.light.a8}",
            $value: "#00001e45",
          },
        },
        dark: {
          1: {
            key: "{color.runtime.gray.dark.1}",
            $value: "#0a0a0c",
          },
          2: {
            key: "{color.runtime.gray.dark.2}",
            $value: "#17171a",
          },
          3: {
            key: "{color.runtime.gray.dark.3}",
            $value: "#212125",
          },
          4: {
            key: "{color.runtime.gray.dark.4}",
            $value: "#29292d",
          },
          5: {
            key: "{color.runtime.gray.dark.5}",
            $value: "#303035",
          },
          6: {
            key: "{color.runtime.gray.dark.6}",
            $value: "#39393f",
          },
          7: {
            key: "{color.runtime.gray.dark.7}",
            $value: "#46464e",
          },
          8: {
            key: "{color.runtime.gray.dark.8}",
            $value: "#5f5f6a",
          },
          9: {
            key: "{color.runtime.gray.dark.9}",
            $value: "#6c6c77",
          },
          10: {
            key: "{color.runtime.gray.dark.10}",
            $value: "#7a7a84",
          },
          11: {
            key: "{color.runtime.gray.dark.11}",
            $value: "#b2b2bb",
          },
          12: {
            key: "{color.runtime.gray.dark.12}",
            $value: "#eeeef0",
          },
          surface: {
            key: "{color.runtime.gray.dark.surface}",
            $value: "#00000000",
          },
          a10: {
            key: "{color.runtime.gray.dark.a10}",
            $value: "#ebebfd80",
          },
          a9: {
            key: "{color.runtime.gray.dark.a9}",
            $value: "#e9e7ff70",
          },
          a6: {
            key: "{color.runtime.gray.dark.a6}",
            $value: "#e8e4fc38",
          },
          a4: {
            key: "{color.runtime.gray.dark.a4}",
            $value: "#ece6fc24",
          },
          a3: {
            key: "{color.runtime.gray.dark.a3}",
            $value: "#e4dcf81c",
          },
          a2: {
            key: "{color.runtime.gray.dark.a2}",
            $value: "#e9dafb0f",
          },
          a1: {
            key: "{color.runtime.gray.dark.a1}",
            $value: "#890a8b03",
          },
          a11: {
            key: "{color.runtime.gray.dark.a11}",
            $value: "#f3f3ffb8",
          },
          a7: {
            key: "{color.runtime.gray.dark.a7}",
            $value: "#e5e2fc47",
          },
          a8: {
            key: "{color.runtime.gray.dark.a8}",
            $value: "#e5e3fd63",
          },
          a12: {
            key: "{color.runtime.gray.dark.a12}",
            $value: "#fcfcfef0",
          },
          contrast: {
            key: "{color.runtime.gray.dark.contrast}",
            $value: "#ffffff",
          },
          a5: {
            key: "{color.runtime.gray.dark.a5}",
            $value: "#ece7ff2b",
          },
        },
      },
    },
  },
};
